export class BdLocaleHelper {
  public static DEFAULT_LOCALE = 'de-DE';

  public static getPreferredLocale(): string {
    const locales = this.getLocales();

    return locales && locales[0] ? locales[0] : this.DEFAULT_LOCALE;
  }

  public static getLocales(): string[] {
    const browserLocales =
      navigator.languages === undefined
        ? [navigator.language]
        : navigator.languages;
    if (!browserLocales) {
      return undefined;
    }
    return browserLocales.map((locale) => {
      return locale.trim();
    });
  }
}
